<template>
	<div class="Login">
		<div class="loginForm">
			<div class="LoginMethod">
				<div @click="SwitchingMethod('password')" class="Method fl" :class="{ highlight: loginMethod }">密码登录<span v-show="loginMethod"></span></div>

				<div class="fl cutApart"></div>

				<div @click="SwitchingMethod('Verification')" class="Method fl" :class="{ highlight: !loginMethod }">
					验证码登录<span v-show="!loginMethod"></span>
				</div>

				<div class="clear"></div>
			</div>
			<div class="EditingArea">
				<div v-show="loginMethod" class="vanField">
					<ul>
						<li>
							<van-field v-model.trim="phone" center clearable :border="false" placeholder="请输入登录账号" />
						</li>
						<li class="passwordInputWrapper">
							<van-field
								v-model.trim="password"
								class="passwordStyle fl"
								center
								clearable
								:type="isVisible"
								placeholder="请输入登录密码"
								:border="false"
							/>

							<div class="VisibleCutApart fl"></div>

							<div class="Visible fr" @click="setVisible">
								<img class="fl" :src="isVisibleImg" alt="" />
							</div>

							<div class="clear"></div>
						</li>
					</ul>
				</div>
				<div v-show="!loginMethod" class="vanField">
					<ul>
						<li>
							<van-field v-model.trim="phone" center clearable :border="false" placeholder="请输入登录账号" />
						</li>
						<li class="authcodeInputWrapper">
							<van-field v-model.trim="Verification" class="VerificationStyle fl" center clearable placeholder="请输入验证码" :border="false" />

							<div
								class="getVerificationStyle fr"
								@click="postAccountGetAuthCode"
								:style="{
									color: Countdown > 0 ? '#BBBBBB' : '#333333',
								}"
							>
								{{ VerificationStatus }}
							</div>

							<div class="clear"></div>
						</li>
					</ul>
				</div>
			</div>
			<div class="OperatingSpace">
				<van-button round type="info" :class="phone && protocol ? 'van-button--info' : 'noneVanButton'" @click="handleLogin">登录</van-button>
				<div class="protocolStyle">
					<van-checkbox v-model="protocol" label-disabled class="myCheckbox"></van-checkbox>
					<span @click="ClearanceAgreement">我同意</span>
					<a @click="goPage('service-agreement')">《用户协议》</a>
					<span>及</span>
					<a @click="goPage('privacy')">《法律声明及隐私政策》</a>
					<div class="clear"></div>
				</div>

				<div class="botton-btn">
					<span class="item left" v-if="canRegister" @click="toRouter('/register_new')">立即注册</span>

					<span class="item right" @click="toRouter('/forget')">忘记密码</span>
					<div class="clear"></div>
				</div>
			</div>
		</div>
		<!-- 选择租户 -->
		<!-- <template v-else-if="showOrgan"> -->
		<template v-if="showOrgan">
			<Organ @handleClose="handleChangeShow" @handleError="handleOrganError" />
		</template>
		<!-- 选择身份 -->
		<template v-else-if="showIdentity">
			<Identity @handleClose="handleShowIdentity" @handleError="handleIdentityError" />
		</template>
	</div>
</template>
<script>
/* eslint-disable */
import Organ from './components/organ'
import Identity from './components/identity'
import config from './../../../config/url'
import yincang from '../../../assets/images/account/icon-yincang.png'
import xianshi from '../../../assets/images/account/icon-xianshi.png'
import md5 from 'js-md5'
import { isPhone, isEmail, isIdentitycard } from '../../../utils/validate'
const agentHost =
	"'agent.saas-h5.testing2.wdeduc.com', 'agent.saas-h5.testing3.wdeduc.com', 'agent.fat.wdeduc.com' , 'agent.uat.wdeduc.com' , 'agent.wdeduc.com', 'localhost:80'"
export default {
	name: 'login',
	data() {
		return {
			showOrgan: false,
			showIdentity: false,
			protocol: true,
			phone: null,
			password: null,
			Verification: null,
			Countdown: 0,
			countdownInterval: null,
			isVisible: 'password',
			place: 'password',
			canRegister: false,
			haveSavedDetailFlag: true, //判断是否保存过
            mobile_prefix: '86',
		}
	},
	computed: {
		loginMethod() {
			return this.place === 'password'
		},
		isVisibleImg() {
			return this.isVisible === 'password' ? yincang : xianshi
		},
		VerificationStatus() {
			if (this.Countdown) {
				return `重新获取 ${this.Countdown}s`
			} else {
				return '发送验证码'
			}
        },
        saasUcode() {
			let pageSetData = this.$store.state.dynamic.pageSetData
			return pageSetData && pageSetData.solutionInfo && pageSetData.solutionInfo.saasUcode
		},
	},
	components: {
		Organ,
		Identity,
	},
	created() {
		localStorage.clear()
		this.initConfig()
		if (!localStorage.getItem('setTempConfigs')) {
			this.getConfigurationNew()
		}
	},
	destroyed() {
		window.removeEventListener('popstate', this.backChange, false) //false阻止默认事件
	},
	mounted() {
		window.addEventListener('popstate', this.backChange, false) //false阻止默认事件
	},
	methods: {
		handleChangeShow() {
			this.showOrgan = false
			this.showIdentity = true
		},
		handleShowIdentity() {
			this.showIdentity = false
			this.findMyBranch()
		},
		handleOrganError() {
			this.showOrgan = false
		},
		handleIdentityError() {
			this.showIdentity = false
		},
		getConfigurationNew() {
			this.$api.configuration.getConfigurationNew().then((data) => {
				let temp = {
					pageHeader: data.data.pageHeader,
					pageHeaderSetting: data.data.pageHeaderSetting,
					pageEndSetting: data.data.pageEndSetting,
					pageEnd: data.data.pageEnd,
					pageUrlList: data.data.pageUrlList,
				}
				localStorage.setItem('setTempConfigs', JSON.stringify(temp))
			})
		},
		ClearanceAgreement() {
			this.protocol = !this.protocol
		},
		//   用户协议跳转页面
		goPage(url) {
			this.$router.push(url)
		},
		initConfig() {
			let frontendConfig = this.$store.state.dynamic.frontendConfig || []
			frontendConfig.length &&
				frontendConfig.forEach((item) => {
					switch (item.key) {
						case 'is_open_register':
							this.canRegister = item.value === 'true' ? true : false
							break
						default:
							break
					}
				})
		},
		toRouter(path) {
			const query = { ...this.$route.query }
			this.$router.push({ path, query })
		},
		SwitchingMethod(val) {
			this.place = val
		},
		setVisible() {
			if (this.isVisible === 'password') {
				this.isVisible = 'text'
				return 0
			}
			this.isVisible = 'password'
		},
		setCountdown() {
			this.countdownInterval = setInterval(() => {
				this.Countdown--
				if (this.Countdown <= 0) {
					this.Countdown = 0
					clearInterval(this.countdownInterval)
				}
			}, 1000)
		},
		postAccountGetAuthCode() {
			if (this.Countdown > 0) return
			// 校验手机号、邮箱
			if (isPhone.test(this.phone) || isEmail.test(this.phone)) {
				this.Countdown = 60
				this.setCountdown()
				this.$sensors.track('UM_Click_Verification _Code_Button')

				// 判断登录账号类型
				let accountTypeArr = [
					{
						extType: 1,
						type: 'phone',
						reg: isPhone,
					},
					{
						extType: 2,
						type: 'email',
						reg: isEmail,
					},
				]
				let accountType = accountTypeArr.find((item) => item.reg.test(this.phone))

				if (accountType.type === 'phone') {
					this.$api.account_new.getPhoneAuthCode4Login({ phone: this.phone, areaCode: this.mobile_prefix })
				} else if (accountType.type === 'email') {
					this.$api.account_new.getMailAuthCode4Login({ mail: this.phone })
				}
			} else {
				this.$notify({
					type: 'warning',
					message: '登录账号格式有误,请检查一下吧',
				})
			}
		},
		async handleLogin() {
			if (!this.protocol) return
			// 保证本地存储最新的
			localStorage.removeItem('organ')
			localStorage.removeItem('actor')
			localStorage.removeItem('branch')
			localStorage.removeItem('token')

			//处理入参字段
			let data = this.handleParams()
			this.$api.account_new.login(data).then((res) => {
				if (res.success) {
					localStorage.setItem('token', res.data)
                    localStorage.setItem('mobile_prefix',this.mobile_prefix)
                    // this.showOrgan = true
                    // 根据域名选择租户
                    console.log('saasucode---------------',this.saasUcode)
                    this.setUserOrgan()
				}
			})
		},
		// 登录参数处理
		handleParams() {
			let hashPassword = ''
			if (this.password) {
				hashPassword = md5(this.password).toLowerCase()
			}
			let data = {
				extType: null, //1:手机号，2:邮箱，3:用户名，4:身份证
				type: this.place === 'password' ? 1 : 2, //1:密码登录，2:验证码登录
				password: hashPassword,
				authCode: this.Verification,
                areaCode: this.mobile_prefix,
			}
			// 判断登录账号类型
			let accountTypeArr = [
				{
					extType: 1,
					type: 'phone',
					reg: isPhone,
				},
				{
					extType: 2,
					type: 'email',
					reg: isEmail,
				},
			]
			let accountType = accountTypeArr.find((item) => item.reg.test(this.phone))
			this.accountType = accountType
			if (!accountType) {
				//用户名登录
				data.extType = 3
				data.username = this.phone
			} else {
				data.extType = accountType.extType
				data[accountType.type] = this.phone
			}
			return data
        },
        setUserOrgan() {
			this.$api.account_new.switchSaas(this.saasUcode).then((res) => {
				if (res.success) {
					this.showIdentity = true
				}
			})
		},
		findMyBranch() {
			this.$api.branch_new.findMyBranch().then((res) => {
				if (res.data && res.data[0]) {
					localStorage.setItem('branchName', res.data[0].name)
					localStorage.setItem('branchUcode', res.data[0].ucode)
					localStorage.setItem('branchList', JSON.stringify(res.data))
					this.switchBranch(res.data[0].ucode)
				}
			})
		},
		switchBranch(branchUcode) {
			this.$api.account_new.switchBranch(branchUcode).then((res) => {
				if (res.success) {
					this.getUserInfo()
				}
			})
		},
		// 获取用户信息
		getUserInfo() {
			this.$api.user_new.getUserInfo().then((res) => {
				if (res.success) {
					this.$store.commit('setUserInfo', res.data)
					this.handleSkip()
				}
			})
		},
		// 成功登录
		handleSkip() {
			if (sessionStorage.getItem('realName')) {
				location.replace('/idcard')
			} else {
				if (this.$route.query.name) {
					if (sessionStorage.getItem('search') && this.$route.query.name === 'goodsDetail') {
						location.replace(this.$route.query.name + sessionStorage.getItem('search'))
					} else {
						let search = null
						if (window.location.search) {
							search = window.location.search
						}
						location.replace(this.$route.query.name + search)
					}
				} else {
					let frontendConfig = this.$store.state.homepage || []
					if (frontendConfig.length && frontendConfig[0].value) {
						console.log('route++++++', frontendConfig[0].value)
						this.$router.push(frontendConfig[0].value)
					} else {
						this.$router.push('/home')
					}
				}
			}
		},
		backChange() {
			const agentHost =
				"'agent.saas-h5.testing2.wdeduc.com', 'agent.saas-h5.testing3.wdeduc.com', 'agent.fat.wdeduc.com' , 'agent.uat.wdeduc.com' , 'agent.wdeduc.com'"

			if (agentHost.includes(window.location.hostname)) {
				//location.reload();
				this.$router.replace({
					path: '/login_new',
					query: {
						name: 'promotionCenter',
						type: new Date().getMinutes(),
					},
				})
			}
		},
	},
}
</script>
<style lang="stylus" scoped>
@import './css/login.styl'
</style>
